import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionRequiredAuthError,
  InteractionType,
  PublicClientApplication,
  SilentRequest,
} from "@azure/msal-browser";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { msalConfig } from "./auth/authConfig";
import { MsalProvider } from "@azure/msal-react";
import { BrowserRouter } from "react-router-dom";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

console.log(process.env.REACT_APP_NAME)

root.render(
  <React.StrictMode>
      <App/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
